export enum ModalAction { POSITIVE, CANCEL }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/components/modal/modelAction.enum.ts